import {cs}       from "../../react/chain-services";
import {UseState} from "../../react/use-state";

export const LoadImgSize = ({next}) => cs(
    ["state", (_, next) => UseState({next})],
    ({state}) => next({
        ...!state.value && {
            ref: (dom) => {
                if (!dom) {
                    return;
                }
                dom.onload = () => {
                    state.onChange({
                        width : dom.naturalWidth,
                        height: dom.naturalHeight,
                    })
                    dom.onload = null;
                }
            },
        },
        value: state.value,
    }),
);

